/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCategoriesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CategoriesDataActions.g';
import { Category } from '@msdyn365-commerce/retail-proxy';
/**
 * GetCategoryDetails Input Action
 */
export class GetCategoryDetailsInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `get-category-details`;
    public getCacheObjectType = () => 'get-category-details';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface IGetCategoryDetailsData {
    categoryDetails: Category | undefined;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCategoryDetailsInput();
};

async function action(input: GetCategoryDetailsInput, ctx: Msdyn365.IActionContext): Promise<IGetCategoryDetailsData> {
    const categoryId = Number(ctx.requestContext.query?.categoryId);
    const getCategories = await getCategoriesAsync(
        { callerContext: ctx },
        ctx.requestContext.apiSettings.channelId
    );
    const getCategoryDetails: Category | undefined = getCategories?.find((item: Category) => item.RecordId === categoryId);
    return {
        categoryDetails: getCategoryDetails
    };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCategoryDetailsData>>action,
    id: 'GetCategoryDetails',
    input: createInput
});
